/*
 * COPYRIGHT:     Copyright © 2020 Xplorie LLC
 * Warning:       This product is protected by United States and international copyright laws.
 *                Unauthorized use or duplication of this software, in whole or in part, is prohibited.
 */

export const TITLE = 'Warning!'
export const MESSAGE = 'Are you sure you want to change the AP Product? All parameters will be lost'
